import styled from "styled-components";

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.75rem;
  cursor: pointer;
`;

export const Input = styled.input`

`;